import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { I18NextNS } from 'src/models/Language.model';

const NotFound = () => {
  const history = useHistory();
  const { t } = useTranslation(I18NextNS.PAGES, { keyPrefix: 'pageNotFound' });
  return (
    <div className="vh-100 d-flex justify-content-center align-items-md-center flex-column gap-4">
      <h1 className="text-center">
        <FontAwesomeIcon icon={faTriangleExclamation} className="me-2" />
        404
      </h1>
      <div className="text-center">
        <h2>{t('title')}</h2>
        <p>{t('desc')}</p>
      </div>

      <Button
        variant="primary"
        onClick={() => history.push('/session-form')}
        data-track="nav.not-found.back-home"
        data-observe
      >
        <FontAwesomeIcon icon={faTriangleExclamation} className="me-2" />
        {t('backHome')}
      </Button>
    </div>
  );
};

export default NotFound;
